export const ADMIN_UPLOAD_HTML_PANEL_ID = 'email-maker-admin-upload-html-panel';

/** Admin-only dialog text (intentionally untranslated). */
export const ADMIN_UPLOAD_HTML_TITLE = 'Import Email HTML';
export const ADMIN_UPLOAD_HTML_UPLOAD_LABEL = 'Upload';
